import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "sv2-step" }
const _hoisted_2 = { class: "sv2-inbox-hero" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { style: {"margin-top":"24px"} }, "Verify your email", -1)
const _hoisted_4 = { class: "sv2-step__subtitle" }
const _hoisted_5 = { class: "sv2-actions" }
const _hoisted_6 = { style: {"display":"flex","align-items":"center","gap":"16px"} }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h1", null, "Verify your email", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-step__subtitle" }, "We sent a 6-digit code to your email address. Enter it below.", -1)
const _hoisted_10 = {
  class: "sv2-fields",
  style: {"gap":"24px"}
}
const _hoisted_11 = { class: "sv2-code-grid" }
const _hoisted_12 = ["id", "value", "disabled", "onInput", "onKeydown"]
const _hoisted_13 = {
  key: 0,
  class: "sv2-field__error"
}
const _hoisted_14 = { class: "sv2-actions" }
const _hoisted_15 = {
  key: 1,
  class: "sv2-verifying"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "sv2-spinner sv2-spinner--dark" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "Verifying...", -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 2,
  class: "sv2-verified"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Email verified", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ph_envelope_open = _resolveComponent("ph-envelope-open")!
  const _component_ph_arrow_left = _resolveComponent("ph-arrow-left")!
  const _component_ph_arrow_right = _resolveComponent("ph-arrow-right")!
  const _component_ph_shield_check = _resolveComponent("ph-shield-check")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.verifyMode === 'inbox')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ph_envelope_open, {
              size: 40,
              weight: "fill"
            })
          ]),
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, [
            _createTextVNode(" We sent a verification link to "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.form.email || 'your email address'), 1),
            _createTextVNode(". Click it, then sign in to your new account. ")
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "sv2-btn-back",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
            }, [
              _createVNode(_component_ph_arrow_left, {
                size: 14,
                weight: "bold"
              }),
              _createTextVNode(" Back ")
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "sv2-btn-subtle",
                type: "button",
                disabled: _ctx.resending,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleResend && _ctx.handleResend(...args)))
              }, _toDisplayString(_ctx.resent ? 'Sent!' : _ctx.resending ? 'Sending…' : 'Resend email'), 9, _hoisted_7),
              _createElementVNode("button", {
                class: "sv2-btn-primary",
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('next')))
              }, [
                _createTextVNode(" Go to sign in "),
                _createVNode(_component_ph_arrow_right, {
                  size: 16,
                  weight: "bold"
                })
              ])
            ])
          ])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.code, (digit, i) => {
                return (_openBlock(), _createElementBlock("input", {
                  key: i,
                  id: `verify-${i}`,
                  type: "text",
                  inputmode: "numeric",
                  maxlength: "1",
                  value: digit,
                  disabled: _ctx.verifying || _ctx.verified,
                  class: "sv2-code-digit",
                  onInput: ($event: any) => (_ctx.handleDigit(i, $event)),
                  onPaste: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handlePaste && _ctx.handlePaste(...args)), ["prevent"])),
                  onKeydown: ($event: any) => (_ctx.handleKeyDown(i, $event))
                }, null, 40, _hoisted_12))
              }), 128))
            ]),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              class: "sv2-btn-back",
              type: "button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('back')))
            }, [
              _createVNode(_component_ph_arrow_left, {
                size: 14,
                weight: "bold"
              }),
              _createTextVNode(" Back ")
            ]),
            (!_ctx.verifying && !_ctx.verified)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "sv2-btn-subtle",
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleResend && _ctx.handleResend(...args)))
                }, " Resend code "))
              : _createCommentVNode("", true),
            (_ctx.verifying)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_18))
              : _createCommentVNode("", true),
            (_ctx.verified)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_component_ph_shield_check, {
                    size: 20,
                    weight: "fill"
                  }),
                  _hoisted_20
                ]))
              : _createCommentVNode("", true)
          ])
        ], 64))
  ]))
}